import { useState, useEffect } from 'react';
import { adminService } from '../services/adminService';

const FALLBACK = '/LOGO.png';
let _cached: string | null = null;

export function useLogo(): string {
  const [url, setUrl] = useState<string>(_cached ?? FALLBACK);

  useEffect(() => {
    if (_cached) return;
    (async () => {
      try {
        const data = await adminService.buscarConfigSaas('whitelabel_config');
        const resolved = (data as { logo_url: string | null } | null)?.logo_url ?? FALLBACK;
        _cached = resolved;
        setUrl(resolved);
      } catch {
        // mantém fallback
      }
    })();
  }, []);

  return url;
}
